import {
    VALET_LISTING_PAGE,
    VALET_INCENTIVE_LIST,
    VALET_INCENTIVE_FILTER,
    EDIT_INCENTIVE_DATA,
    LAST_FIVE_TRANSACTIONS,
    VALET_BULK_APPROVAL
} from "./type";

const initalState = {
    valetincentivelist: [],
    valetincentivelisting: [],
    valetIncentiveFilter: [],
    editIncentiveData: [],
    lastFiveTransactionsList: [],
    bulkApprovalData: []
};

const ValetIncentive = (state = initalState, action) => {
    const {type, payload} = action;
    switch (type) {
        case VALET_LISTING_PAGE:
            return {
                ...state,
                valetincentivelist: payload
            };
        case VALET_INCENTIVE_LIST:
            return {
                ...state,
                valetincentivelisting: payload
            };
        case VALET_INCENTIVE_FILTER:
            return {
                ...state,
                valetIncentiveFilter: payload,
            };
        case EDIT_INCENTIVE_DATA:
            return {
                ...state,
                editIncentiveData: payload,
            };
        case LAST_FIVE_TRANSACTIONS:
            return {
                ...state,
                lastFiveTransactionsList: payload,
            };
        case VALET_BULK_APPROVAL:
            return {
                ...state,
                bulkApprovalData: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default ValetIncentive;
